import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React from 'react'

const DateField = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'pr-br'}>
      <DatePicker
        autoOk
        variant="inline"
        openTo="day"
        inputVariant="outlined"
        margin="dense"
        format="DD/MM/YYYY"
        size="small"
        invalidDateMessage="Data inválida"
        {...props}
        views={['year', 'month', 'day']}
        slotProps={{
          ...props?.slotProps,
          textField: {
            ...props?.slotProps?.textField,
            fullWidth: true,
            margin: 'dense',
            variant: 'outlined',
            size: 'small',
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default DateField
